import { Checkbox } from '@hotjar/hotsauce';
import { useProRataCost } from '@hotjar/webapp/features/Settings/SitesAndOrganizations/Site/CreateSite/hooks/useProRataCost';
import type { PricingTable } from '@hotjar/webapp/domains/revenue/pricing/types';
import { Trans, useTranslation } from 'react-i18next';
import { DecoratedTooltip } from '@hotjar/insights-common/components/DecoratedTooltip';
import * as React from 'react';
import { ErrorMessage } from '@hotjar/webapp/features/Settings/SitesAndOrganizations/Site/CreateSite/styles';

const Bold = ({ children }: { children?: React.ReactNode }): JSX.Element => <b>{children}</b>;

export const NewSiteCostConfirmation = ({
  accountPricingTable,
  selectedPlanId,
  selectedOrgId,
  onChange,
  isChecked,
  errorMessage,
}: {
  accountPricingTable: PricingTable;
  selectedPlanId: string;
  selectedOrgId: string;
  onChange: (isChecked: boolean) => void;
  isChecked: boolean;
  errorMessage?: string;
}): JSX.Element => {
  const { t } = useTranslation('account');
  const { totalRecurringCost, newSiteRecurringCost, proRataCost, billingCycleTerm } =
    useProRataCost(accountPricingTable, selectedPlanId, selectedOrgId);

  return (
    <Checkbox
      isChecked={isChecked}
      onChange={() => onChange(!isChecked)}
      labelContent={
        <span>
          {proRataCost ? (
            <Trans
              t={t}
              i18nKey="create-site.cost.pro-rata"
              values={{
                proRataCost,
                newSiteRecurringCost,
                totalRecurringCost,
                billingCycleTerm,
              }}
            >
              <DecoratedTooltip text={t('create-site.cost.pro-rata-tooltip')} isBold isUnderline />
              <Bold />
            </Trans>
          ) : (
            <Trans
              t={t}
              i18nKey="create-site.cost.full-cost"
              values={{
                newSiteRecurringCost,
                totalRecurringCost,
                billingCycleTerm,
              }}
            >
              <Bold />
            </Trans>
          )}

          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </span>
      }
    />
  );
};
